var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logoUrl)?_c('div',{staticClass:"logo-block"},[_c('img',{staticClass:"logo center",attrs:{"src":_vm.logoUrl,"title":"Application"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }